export enum PaymentsImportSummary {
  GET_PAYMENTS_IMPORT_SUMMARY = "GET_PAYMENTS_IMPORT_SUMMARY",
  GET_PAYMENTS_IMPORT_SUMMARY_SUCCESS = "GET_PAYMENTS_IMPORT_SUMMARY_SUCCESS",
  GET_PAYMENTS_IMPORT_SUMMARY_FAIL = "GET_PAYMENTS_IMPORT_SUMMARY_FAIL",
}
